/* Other ranges use their own published products/tags/artwork, never the R.ONE map. */
(function () {
  'use strict';
  var tools = document.querySelector('[data-paint-collection]');
  if (!tools || tools.dataset.filterBound) return;
  tools.dataset.filterBound = 'true';
  var family = tools.querySelector('select');
  var search = tools.querySelector('input[type="search"]');
  var clear = tools.querySelector('button');
  var status = document.getElementById('RoneFilterStatus');
  var grid = document.getElementById('RoneCollectionGrid');
  var server = document.getElementById('RoneServerPagination');
  var pager = document.getElementById('RoneClientPagination');
  if (!family || !search || !grid || !status || !pager) return;
  var handle = tools.dataset.paintCollection;
  var pageSize = Number(grid.dataset.pageSize) || 20;
  var promise, revision = 0, timer, currentPage = 1;
  var money = new Intl.NumberFormat('en-SG', { style: 'currency', currency: tools.dataset.currency || 'SGD' });
  function normal(value) { return String(value || '').toLowerCase().replace(/[’']/g, '').replace(/\brp\s*(\d)/g, 'rp $1').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function node(tag, classes, value) {
    var el = document.createElement(tag);
    if (classes) el.className = classes;
    if (value !== undefined) el.textContent = value;
    return el;
  }
  function load() {
    if (promise) return promise;
    var count = Math.max(1, Math.ceil(Number(tools.dataset.productCount) / 250));
    var requests = [];
    for (var p = 1; p <= count; p++) {
      requests.push(fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + p, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok) throw new Error('Colours unavailable');
        return res.json();
      }));
    }
    promise = Promise.all(requests).then(function (pages) {
      var seen = new Set(), products = [];
      pages.forEach(function (page) {
        if (!Array.isArray(page.products)) throw new Error('Invalid colour response');
        page.products.forEach(function (product) { if (!seen.has(product.id)) { seen.add(product.id); products.push(product); } });
      });
      return products;
    }).catch(function (error) { promise = null; throw error; });
    return promise;
  }
  function card(product, index) {
    var outer = node('div', 'grid__item grid-product rone-filter-card');
    var content = node('div', 'grid-product__content');
    var link = node('a', 'grid-product__link');
    link.href = '/collections/' + encodeURIComponent(handle) + '/products/' + encodeURIComponent(product.handle);
    var mask = node('div', 'grid-product__image-mask');
    var wrap = node('div', 'image-wrap');
    var source = product.images && product.images[0];
    if (source) {
      var image = node('img', 'grid-product__image rone-filter-card__image');
      image.src = source.src + (source.src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
      image.alt = product.title;
      image.loading = index < 4 ? 'eager' : 'lazy'; image.decoding = 'async';
      image.width = source.width || 600; image.height = source.height || 600;
      wrap.appendChild(image);
    }
    mask.appendChild(wrap); link.appendChild(mask);
    var meta = node('div', 'grid-product__meta');
    var title = node('div', 'grid-product__title');
    var match = product.title.match(/^(.*?)\s+RP\s*([\d-]+)/i);
    if (match) {
      var row = node('div', 'title-row');
      row.appendChild(node('span', 'name', match[1]));
      row.appendChild(node('span', 'rp-top', 'RP ' + match[2])); title.appendChild(row);
    } else title.textContent = product.title;
    meta.appendChild(title);
    var prices = (product.variants || []).map(function (v) { return Number(v.price); }).filter(Number.isFinite);
    if (prices.length) {
      var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
      meta.appendChild(node('div', 'grid-product__price', (min !== max ? 'From ' : '') + money.format(min)));
    }
    if (!(product.variants || []).some(function (v) { return v.available; })) content.appendChild(node('div', 'grid-product__tag', 'Sold out'));
    link.appendChild(meta); content.appendChild(link); outer.appendChild(content);
    return outer;
  }
  function button(value, label, active) {
    var b = node('button', '', label);
    b.type = 'button'; b.dataset.page = value;
    if (active) b.setAttribute('aria-current', 'page');
    return b;
  }
  function pagination(total) {
    pager.replaceChildren(); pager.hidden = total <= 1;
    if (currentPage > 1) { var prev = button(currentPage - 1, '‹'); prev.setAttribute('aria-label', 'Previous colour page'); pager.appendChild(prev); }
    var last = 0;
    for (var p = 1; p <= total; p++) {
      if (p !== 1 && p !== total && Math.abs(p - currentPage) > 1) continue;
      if (last && p - last > 1) pager.appendChild(node('span', 'rone-pagination__ellipsis', '…'));
      var b = button(p, p, p === currentPage); b.setAttribute('aria-label', 'Colour page ' + p); pager.appendChild(b); last = p;
    }
    if (currentPage < total) { var next = button(currentPage + 1, '›'); next.setAttribute('aria-label', 'Next colour page'); pager.appendChild(next); }
  }
  function saveUrl() {
    var url = new URL(location.href);
    url.pathname = '/collections/' + handle;
    url.searchParams.delete('page');
    [['paint_family', family.value], ['paint_search', search.value.trim()], ['paint_page', currentPage > 1 ? currentPage : '']].forEach(function (entry) {
      if (entry[1]) url.searchParams.set(entry[0], entry[1]); else url.searchParams.delete(entry[0]);
    });
    history.replaceState({}, '', url);
  }
  function render(page, update, scroll) {
    var request = ++revision;
    var selected = family.value, query = normal(search.value), terms = query.split(' ').filter(Boolean);
    var exactCode = search.value.trim().match(/^rp\s*(\d+)\s*[- ]\s*(\d+)$/i);
    clear.hidden = !search.value;
    grid.setAttribute('aria-busy', 'true'); status.textContent = 'Finding colours…';
    load().then(function (products) {
      if (request !== revision) return;
      var matches = products.filter(function (product) {
        var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
        var tagMatch = !selected || tags.some(function (tag) { return normal(tag) === normal(selected); });
        var title = normal(product.title + ' ' + product.handle);
        var code = product.title.match(/\bRP\s*(\d+)-(\d+)/i);
        return tagMatch && (exactCode ? code && code[1] === exactCode[1] && code[2] === exactCode[2] : terms.every(function (term) { return title.indexOf(term) !== -1; }));
      });
      var pages = Math.max(1, Math.ceil(matches.length / pageSize));
      currentPage = Math.min(Math.max(1, page || 1), pages);
      var fragment = document.createDocumentFragment();
      matches.slice((currentPage - 1) * pageSize, currentPage * pageSize).forEach(function (product, index) { fragment.appendChild(card(product, index)); });
      if (!matches.length) fragment.appendChild(node('p', 'rone-collection__empty', 'No colours match. Try another name, RP code or family.'));
      grid.replaceChildren(fragment);
      if (server) server.hidden = true;
      pagination(pages);
      status.textContent = matches.length + (matches.length === 1 ? ' colour' : ' colours') + (pages > 1 ? ' · Page ' + currentPage + ' of ' + pages : '');
      if (update) saveUrl();
      if (scroll) grid.scrollIntoView({ behavior: 'auto', block: 'start' });
    }).catch(function () {
      if (request !== revision) return;
      status.textContent = 'Colour search could not load. Your current colours are still shown; please try again.';
    }).finally(function () { if (request === revision) grid.setAttribute('aria-busy', 'false'); });
  }
  family.addEventListener('change', function () { clearTimeout(timer); render(1, true); });
  search.addEventListener('input', function () {
    ++revision; clear.hidden = !search.value;
    clearTimeout(timer); timer = setTimeout(function () { render(1, true); }, 180);
  });
  clear.addEventListener('click', function () { clearTimeout(timer); search.value = ''; search.focus(); render(1, true); });
  pager.addEventListener('click', function (event) {
    var target = event.target.closest('button[data-page]');
    if (target && target.getAttribute('aria-current') !== 'page') render(Number(target.dataset.page), true, true);
  });
  function restore() {
    var params = new URL(location.href).searchParams;
    if (params.has('paint_family')) family.value = params.get('paint_family');
    search.value = params.get('paint_search') || '';
    if (params.has('paint_family') || search.value || params.has('paint_page')) render(Number(params.get('paint_page')) || 1, false);
  }
  window.addEventListener('popstate', function () { family.value = ''; search.value = ''; render(1, false); restore(); });
  restore();
}());
